<template lang="html">
  <nav :class="thisClass" class="navbar-main navbar fixed-top navbar-toggleable navbar-expand">
    <div class="container">
      <ul v-if="$auth.check()" class="nav navbar-nav pull-sm-left">
        <li class="nav-item nav-item-user-menu dropdown">
          <a class="nav-link dropdown-toggle" href="#" id="home-menu" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            <span class="name"><i class="micon-apps"></i></span>
          </a>
          <div class="dropdown-menu" aria-labelledby="user-menu">
            <router-link :to="{name: 'TransactionList'}" class="dropdown-item text-right-"><i class="micon-valid"></i> Transações</router-link>
            <router-link :to="{name: 'ValidationList'}" class="dropdown-item text-right-"><i class="micon-id"></i> Validações</router-link>
            <router-link :to="{name: 'CustomerService'}" class="dropdown-item text-right-"><i class="micon-friends"></i> Atendimento</router-link>
          </div>
        </li>
      </ul>
      <ul class="nav navbar-nav navbar-brand navbar-logo mx-auto">
        <li class="nav-item">
          <router-link :to="{name: 'Home'}"><img src="../../../assets/images/boletoflex-logo.png" alt=""></router-link>
        </li>
      </ul>
      <ul class="nav navbar-nav pull-sm-right" v-if="$auth.check()">
        <li class="nav-item nav-item-user-menu dropdown">
          <a class="nav-link dropdown-toggle" href="#" id="user-menu" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            <span>{{ $auth.user().displayName }}</span>
          </a>
          <div class="dropdown-menu" aria-labelledby="user-menu">
            <a v-on:click="logout()" href="javascript:void(0);" class="dropdown-item text-right-"><i class="micon-close"></i> Sair</a>
          </div>
        </li>
      </ul>
      <!-- <button class="navbar-toggler navbar-toggler-right" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button> -->
    </div>
  </nav>
</template>

<script>
export default {
  props: {
    profilePicture: {
      required: true
    },
    type: {
      default: 'default'
    },
    active: {
      default: 0
    }
  },
  computed: {
    thisClass: function () {
      if (this.type) {
        return 'navbar-' + this.type
      }
    }
  },
  mounted () {
  },
  methods: {
    logout () {
      this.$auth.logout({
        makeRequest: false,
        success () {
          console.log('success ' + this.context)
          this.$router.replace('/login')
        },
        error () {
          console.log('error ' + this.context)
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../assets/scss/variaveis.scss";
@import "@coreui/coreui/dist/css/coreui.css";

li {
  padding: 0;
}
.navbar-main {
  background-color: white;
  /*box-shadow: 0 2px 14px rgba(0,0,0,.2);*/
  height: 70px;
  padding: 0!important;

  .navbar-brand {
    img {
      max-height: 40px;
    }
  }
  a {
    color: #3A3F73;
    font-family: $font-button;
  }

  .dropdown .nav-link {
    background: #fff;
    padding: 0 14px;

  }
  .dropdown.show .nav-link {
    background: #f9f9f9;
  }
  .dropdown-menu {
    background: #f9f9f9;
    margin: 0;
    border: 0;
    border-radius: 0;
    box-shadow: 0 2px 14px rgba(0,0,0,.2);
    z-index: -1;
    right: 0;
    left: initial;
    padding: 0;

    .dropdown-item {
      font-family: $font-text-boletoflex;
      font-size: 14px;
      padding: 10px 20px;

      &:hover {
        background-color: white;
      }
      &:active, &.focus {
        background-color: $secondary-color;
      }
    }
  }

  .avatar {
    display: inline-block;
    overflow: hidden;
    border-radius: 50%;
    margin-right: 10px;
  }
  .navbar-nav {
    position: relative;
    background: white;
    flex-direction: row;
    display: flex;

    .nav-item {
      &.active {
        .nav-link {
          background: #eee;
        }
      }
      .nav-link {
        display: flex;
        align-items: center;
        flex-direction: row;
        height: 70px;
        position: relative;

        .nav-link-badge {
          background-color: $danger-color;
          display: block;
          width: 20px;
          height: 20px;
          border-radius: 50%;
          position: absolute;
          right: 0;
          bottom: 0;
          font-size: 10px;
          color: #fff;
          text-align: center;
          line-height: 18px;
          font-family: $font-text-boletoflex;
          background-color: $danger-color;
          bottom: 17px;
          font-size: 10px;
          line-height: 19px;
          font-weight: 700;
        }
      }
      .avatar{
        display: inline-block;
        width: 30px;

        img {
          max-width: 100%;
        }
      }
    }
  }
  .navbar-nav {
    .nav-item-link {
      margin-right: 0;
      position: initial;
      .nav-link {
        padding: 0 14px;
      }
      i {
        font-size: 20px;
        margin-right: 5px;
        position: relative;
        top: -1px;
      }
    }
  }

  // NOTIFICATION
  .nav-item-notification-menu {
    margin-right: 20px;
    position: initial;

    i {
      font-size: 22px;
    }

    .dropdown-body {
      max-height: 200px;
      overflow: auto;
      @include scrollbar(4);
    }

    .dropdown-header {
      border-bottom: 1px solid rgba(0,0,0,.1);
      text-align: center;
      color: #888;
      font-family: $font-title;
    }

    .notification {
      overflow: hidden;
      .notification-image{
        width: 40px;
        float: left;
        margin: 0 10px 0 0;

        img {
          max-width: 100%;
        }
      }
      .notification-title{
        font-family: $font-text-boletoflex;
        display: block;
        line-height: 14px;
        white-space: normal;
      }
      .notification-date{
        font-family: $font-text-boletoflex;
        display: block;
        color: rgba(0,0,0,.5);
      }
    }
  }

  // USER MENU
  .nav-item-user-menu {
    position: initial;

    .nav-link {
      display: flex;
      align-items: center;
      flex-direction: row;
    }
    .dropdown {
      border: 0;
      border-radius: 0;
      top: 54px;
    }
    .dropdown-menu {
      i {
        margin-right:6px;
      }
    }
  }

  @include media-breakpoint-down(sm) {

    .nav-item-link {
      .nav-link {
        padding: 0 20px!important;
        i {
          margin: 0;
        }
      }
      span {
        display: none;
      }
    }
  }
  @include media-breakpoint-down(xs) {

    .navbar-brand {
      margin: 0;
      img {
        max-width: 100px;
      }
    }
    .nav-item-link {
      .nav-link {
        padding: 0 7px!important;
        i {
          margin: 0;
        }
      }
      span {
        display: none;
      }
    }

    .nav-item-notification-menu .dropdown-body {
        max-height: calc(100vh - 120px);
        overflow: auto;
    }

    .container {
      width: 100%;
    }
    .navbar-nav {
      flex-direction: row;
      float: right;
      position: initial;
      background-color: transparent;
      .dropdown-menu {
        position: absolute;
        left: 0;
        right: 0;
      }
      .nav-link {
        background-color: transparent;
      }

    }
    .navbar-brand {
      height: 70px;
      float: left;
      display: flex;
      align-items: center;
      padding-left: 10px;
    }
    .nav-item-user-menu {
      .name {
        display: none;
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/partial/navbar/Navbar.vue